export enum TipoNotificacionEnum {
    TICKET = 'TICKET',
    DEFECTO = 'DEFECTO',
    OPORTUNIDAD = 'OPORTUNIDAD',
    TAREA = 'TAREA',
    PROYECTO = 'PROYECTO',
    INCIDENCIA_IA = 'INCIDENCIA_IA',
    INCIDENCIA_SEGURIDAD = 'INCIDENCIA_SEGURIDAD',
    INCIDENCIA_HOST = 'INCIDENCIA_HOST',
    // Balanced Scorecard FOR-011 (tipo 9 en TipoNotificacionEnum de CosCore).
    BSC = 'BSC'

}
